<template>
  <Modal width="700"
         v-model="modal.applyVisible"
         title="分销申请">
    <Form class="form"
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="120">

      <FormItem label="供应商："
                style="width: 260px;">
        <span>{{shopName}}</span>
      </FormItem>
      <!--        <FormItem label="分销等级" prop="distributionLevel">-->
      <!--          <Select v-model="formValidate.distributionLevel" placeholder="请选择分销等级">-->
      <!--            <Option value="0">默认等级</Option>-->
      <!--          </Select>-->
      <!--        </FormItem>-->
      <FormItem label="会员账号："
                style="width: 400px;">
        <span>{{username? username: '--'}}</span>
      </FormItem>
      <FormItem label="联系人姓名："
                prop="name"
                style="width: 400px;">
        <Input maxlength="10" v-model="formValidate.name">
        </Input>
      </FormItem>
      <FormItem label="联系人手机："
                prop="phone"
                style="width: 400px;">
        <Input v-model="formValidate.phone">
        </Input>
      </FormItem>
      <FormItem label="选择加盟的网店：" prop="online">
        <CheckboxGroup v-if="storeList && storeList.length > 0" v-model="formValidate.online">
          <Checkbox :label="item.shopId" v-for="(item,index) in storeList" :key="index">{{item.shopName}}</Checkbox>
        </CheckboxGroup>
        <router-link v-else :to="{path: '/user/menuLayout/authorization'}">
          您还未绑定网店，请立即绑定
        </router-link>
      </FormItem>
      <FormItem label="联系人QQ："
                prop="contactQq"
                style="width: 400px;">
        <Input v-model="formValidate.contactQq">
        </Input>
      </FormItem>
      <FormItem label="申请留言："
                prop="message">
        <Input type="textarea"
               maxlength="200"
               show-word-limit
               :autosize="{minRows: 6,maxRows: 10}"
               v-model="formValidate.message">
        </Input>
      </FormItem>
    </Form>
    <div slot="footer"
         style="text-align:center;">
      <Button type="primary"
              style="width: 128px; border-radius: 0;"
              @click="handleSubmit('formValidate')">提交申请
      </Button>
    </div>
  </Modal>
</template>

<script>
  import { mapState } from 'vuex'
  import { applyDMcht} from '@/api/user'

  export default {
    name: 'index',
    props: {
      modal: Object,
      shopName: String,
      storeList: Array
    },
    data () {
      const validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请填写手机号码'))
        } else {
          if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
            callback(new Error('手机号码格式有误'))
          } else {
            callback()
          }
        }
      }
      return {
        formValidate: {
          contactQq: '',
          distributionLevel: 0,
          mchtId: 0,
          memberId: 0,
          message: '',
          name: '',
          onlineStore: '',
          online: [],
          phone: '',
          username: ''
        },
        ruleValidate: { // 校验提交地址
          name: [
            {
              required: true,
              message: '请填写联系人姓名',
              trigger: 'blur'
            }
          ],
          phone: [
            {
              required: true,
              validator: validatePhone,
              trigger: 'blur'
            }
          ],
          contactQq: [
            {
              required: true,
              message: '请填写QQ号',
              trigger: 'blur'
            }
          ],
          online: [
            {
              required: true,
              type: 'array',
              min: 1,
              message: '请选择加盟的网店',
              trigger: 'change'
            }
          ],
        },
      }
    },
    mounted () {
    },
    methods: {
      handleSubmit (name) {
        this.$refs[name].validate((valid) => {
          this.formValidate.mchtId = this.$route.query.shopId
          this.formValidate.memberId = this.userid
          this.formValidate.username = this.username
          this.formValidate.onlineStore = this.formValidate.online.join(',')
          console.log('formValidate', this.formValidate)
          if (valid) {
            applyDMcht(this.formValidate).then(res => {
              this.$Message.success(res.message)
              this.modal.applyVisible = false
            })
          } else {
            this.$Message.error('请检查必要项！')
          }
        })
      },

    },
    computed: {
      ...mapState(['userid', 'username'])
    },
  }
</script>

<style scoped>
  .form {
    width: 500px;
    margin: 0 auto;
  }
</style>
